<template>
  <div class="o-retain o-retain--wall">
    <span v-if="total > 0" v-html="$label('noUnitResultsMessage')" />
    <span v-else v-html="$label('noResultsMessage')" />
    <p>
      <button-component
        modifier
        :label="$label('clearfilter')"
        :click-callback="onClearFilters"
      />
    </p>
  </div>
</template>

<script>
import Button from '@/components/Utilities/Button.vue'

export default {
  name: 'NoResults',
  props: {
    total: Number
  },
  components: {
    'button-component': Button,
  },
  methods: {
    onClearFilters() {
      this.$store.dispatch('clearFilters')
    },
  },
}
</script>
